export default __webpack_public_path__ + "static/media/Vector2.6d93263a.svg";